<template>
  <div>
    <div class="relative my-8">
      <span
        class="toggle text-sm text-gray-muted border border-gray-120 rounded-lg px-5 py-3 font-normal"
        @click="showDetails = !showDetails"
      >
        {{ showDetails ? 'Hide Details' : 'See Details' }}
        <arrow-icon
          color="#5D5E68"
          size="h-5 w-5"
          :class="showDetails ? '' : 'rotate-180 transform'"
        />
      </span>
      <hr />
    </div>

    <transition name="slide-fade">
      <div
        v-if="showDetails"
        class="flex flex-col sm:flex-row sm:items-center gap-x-32 pr-10"
      >
        <div class="flex flex-col">
          <span
            class="font-medium text-black-10 text-xs lg:text-sm inline-flex gap-x-1 items-center bg-gray-30 px-3 py-2 rounded"
          >
            <calendar-icon color="#A5A7B6" />
            One Time Payout
          </span>

          <div class="mt-3 sm:mt-6 pl-5">
            <p class="font-normal text-gray-muted text-xs lg:text-sm">
              Date Created
            </p>
            <p class="font-medium text-black-10 text-xs lg:text-sm mt-1">
              {{
                bulkPayoutDetails.createdAt
                  ? parseRelativeTime(bulkPayoutDetails.createdAt)
                  : '--'
              }}
            </p>
          </div>
        </div>

        <div class="verticalLine hidden sm:block"></div>

        <div v-if="isSingleBulkPayout && isAwaitingApprovalStatus">
          <span
            class="mt-6 sm:mt-0 font-medium text-black-10 text-xs lg:text-sm inline-flex gap-1 items-center bg-gray-30 px-3 py-2 rounded"
          >
            Initiator's Details
          </span>

          <div
            class="mt-3 sm:mt-6 pl-5 flex flex-col sm:flex-row gap-4 sm:gap-32"
          >
            <div v-for="(item, index) in transactionDetails" :key="index">
              <p class="font-normal text-gray-muted text-xs lg:text-sm">
                {{ item.label }}
              </p>
              <p
                class="font-medium text-black-10 text-xs lg:text-sm mt-1 capitalize"
              >
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="isMultipleBulkPayout && isAwaitingApprovalStatus">
          <p class="mt-6 sm:mt-0 font-light text-gray-muted text-sm">
            Initiator's Details
          </p>
          <p
            class="text-black-10 text-base font-medium capitalize mt-2 sm:mt-4"
          >
            {{ initiatorInfo.firstName }} {{ initiatorInfo.lastName }}
          </p>
          <span
            @click="openInitiatorDrawer"
            class="text-primary text-sm font-normal flex gap-4 items-center cursor-pointer hover:opacity-60"
            >See more
            <arrow-icon
              color="var(--color-primary)"
              size="h-5 w-5"
              class="-rotate-90 transform"
          /></span>
        </div>
      </div>
    </transition>

    <hr class="my-8" v-show="showDetails" />
  </div>
</template>

<script>
import { ParseRelativeTime } from '@/utils/helpers'
import userKinds from '@/mixins/userKinds.js'

export default {
  mixins: [userKinds],
  props: {
    isSingleBulkPayout: {
      type: Boolean,
      default: false
    },
    isMultipleBulkPayout: {
      type: Boolean,
      default: false
    },
    isAwaitingApprovalStatus: {
      type: Boolean,
      default: false
    },
    transactionDetails: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDetails: true
    }
  },
  components: {
    CalendarIcon: () => import('@/assets/v2/icons/CalendarIcon.vue'),
    ArrowIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue')
  },
  computed: {
    bulkPayoutDetails () {
      return this.$store.state.bulkPayout.currentBulkPayoutDetails.items
    }
  },
  methods: {
    parseRelativeTime (val) {
      return ParseRelativeTime(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle {
  background-color: white;
  cursor: pointer;
  position: absolute;
  display: inline-flex;
  align-items: center;
  left: 45%;
  top: -22px;
  gap: 4px;
  transition: all 0.8s ease;
}
.verticalLine {
  height: 110px;
  width: 1px;
  background-color: #e1e3f2;
}
</style>
